export default __webpack_public_path__ + "static/media/shutterstock_1238855797.33f3e033.png";